/* eslint-disable import/no-cycle */
import {executeGet, executePost} from '../requests';

const resourcesName = 'v1/storage-units';

export const getOrCreateStorageUnitEndpoint = 'getOrCreate';
const getOrCreateStorageUnitResource = 'get-or-create';

export const StorageUnitsApi = {
  all: ({...params}) => executeGet(resourcesName, {params}),
  byId: (id) => executeGet(`${resourcesName}/${id}`),
  [getOrCreateStorageUnitEndpoint]: ({no}) => executePost(
    `${resourcesName}/${getOrCreateStorageUnitResource}/${encodeURIComponent(no)}`
  ),
};
